var sika = sika || {};
( function () {
    'use strict';
    jQuery( window ).scroll( function () {
        var scroll = jQuery( window ).scrollTop();
        if ( scroll >= 500 ) {
            jQuery( '.e-header' ).addClass( 'sika-header-scroll-background' );
        }
        else {
            jQuery( '.e-header' ).removeClass( 'sika-header-scroll-background' );
        }
    } );
    jQuery( function () {
        sika.initOnReady();
        var initial = true;
        if(jQuery( '.js-e-productlist-v2' ).length){
            sika.productsheet.init( initial );
            initial = false;
        }
    } );
    jQuery( window ).on( 'load', function () {
        sika.initOnLoad();
    } );
    jQuery( '.e-dropdown-mega .dropdown-toggle' ).click( function ( event ) {
        jQuery( '.e-header' ).toggleClass( 'sika-header-background' );
    } );
    jQuery( document ).click( function ( e ) {
        if ( !jQuery( e.target ).closest( '.e-header .sika-header-background' ).length ) {
            jQuery( '.sika-header-background' ).toggleClass( 'sika-header-background' );
        }
    } );
    jQuery( '.p-carousel' ).on( 'slide.bs.carousel', function ( event ) {
        jQuery('.carousel-dropdown[data-parent-carousel="'+event.target.id+'"]').collapse('hide');
    } );
    jQuery('.carousel-dropdown').on('shown.bs.collapse', function(event){
        var intScrollTop = e4.scrollToAnchor.getTarget(event.target);
        e4.scrollToAnchor.animate(intScrollTop);
    });
    sika.initOnReady = function () {
        sika.video.fit();
        sika.forms.init();
        sika.ecom.init();
        sika.cart.init();
        sika.modalFreeze.init();
        sika.customercenter.init();
        sika.inlineSearch();
        sika.carousel.init();
    };
    sika.initOnLoad = function () {
        sika.video.play();
        sika.nav();
        sika.shoefinder.init();
        sika.favorites.init();
        if ( jQuery( '.js-e-product' ).length ) {
            sika.productsheet.init(); //Productlist pdf script inited in ecom.productlist.js
        }
        sika.popup.init();
    };

    sika.inlineSearch = function () {
        jQuery( '.js-sika-inline-search-form' ).on( 'submit', function ( event ) {
            event.preventDefault();
            var searchValue = jQuery( event.target ).find( '.js-e-inline-search-input' ).val();
            e4.util.hash.set( 'search', searchValue );
        } );
    }
    /*
    sika.validateZipCode = function(zipcode, countryCode) {
        const apiKey = 'AIzaSyD26A9gZslnIhz9wLjeCeKLi1PcUeWfNqM';
        return fetch('https://maps.googleapis.com/maps/api/geocode/json?address='+zipcode+'&key='+apiKey+'&components=country:'+countryCode);
    }
    sika.testerman = function(){
        let returnValue = false;
        sika.validateZipCode(7500, 'DK').then(function(resp){
            return resp.json();
        }).then(function(json){
            if(json.status === 'OK' && json.results.length > 0){
                const hasMatch = json.results[0].address_components.filter(function(ac){
                    return ac.types.indexOf('postal_code') > -1;
                }).length > 0;
                
                if(hasMatch === true){
                    console.log('match');
                }
            }
        })
    }
    
     */
    
    sika.utils = {
        isTouchDevice: function () {
            return 'ontouchstart' in window || navigator.maxTouchPoints;
        }
    };
    sika.video = {
        fit: function () {
            var jVideo = jQuery( '.js-sika-video-movie' );
            if ( jVideo.length > 0 ) {
                objectFitPolyfill( jVideo );
            }
        },
        play: function () {
            var jVideo = jQuery( '.js-sika-video-movie' );
            if ( jVideo.length > 0 ) {
                jVideo.addClass( 'is-ready' );
                jVideo.get( 0 ).play();
            }
        }
    };
    sika.modalFreeze = {
        init: function () {
            if ( sika.utils.isTouchDevice() === true ) {
                jQuery( '.modal' ).on( 'shown.bs.modal', function ( e ) {
                    jQuery( 'html' ).addClass( 'sika-modal-freeze-page' );
                    jQuery( 'body' ).addClass( 'sika-modal-freeze-page' );
                } );
                jQuery( '.modal' ).on( 'hidden.bs.modal', function ( e ) {
                    jQuery( 'html' ).removeClass( 'sika-modal-freeze-page' );
                    jQuery( 'body' ).removeClass( 'sika-modal-freeze-page' );
                } );
            }
        }
    };
    sika.cart = {
        init: function () {
            sika.cart.bindEvents();
            if ( jQuery( '.js-sika-add-to-cart-by-excel-products-container' ).length === 1 ) {
                e4.util.require.js( e4.settings.require.handlebars, function () {
                    e4.handlebars.registerHelpers( 'compare' );
                    sika.cart.addByExcel.registerHelpers();
                    e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-add-to-cart-by-excel-products' );
                } );
            }
        },
        bindEvents: function () {
            jQuery( '.js-e-cart' ).on( 'updated.e4.cart', function () {
                jQuery( '[data-toggle="tooltip"]' ).tooltip( {
                    container: 'body'
                } );
            } );
            jQuery( '.js-sika-add-to-cart-by-excel-upload-form' ).on( 'submit', function ( event ) {
                event.preventDefault();
                sika.cart.addByExcel.load( event.target ).done( function ( jsonData, status, xhr ) {
                    if ( xhr.status === 204 ) {
                        return alert( 'Please select a file to upload' );
                    }
                    jQuery(event.target).addClass('d-none');
                    sika.cart.addByExcel.sortData( jsonData );
                } ).fail( function ( err ) {console.error( err );} );

            } );
            jQuery( '.js-sika-add-to-cart-by-excel-input' ).on( 'change', function ( event ) {
                if ( event.target.value ) {
                    var label = event.target.value.replace( /\\/g, '/' ).replace( /.*\//, '' );
                    jQuery( '.js-form-group-file-label' ).html( '<i class="material-icons">check</i> ' + label );
                    jQuery( '.js-sika-add-to-cart-by-excel-button' ).prop( 'disabled', false );
                }
                else {
                    jQuery( '.js-form-group-file-label' ).html( event.target.dataset.emptyText );
                    jQuery( '.js-sika-add-to-cart-by-excel-button' ).prop( 'disabled', true );
                }

            } );
            jQuery( '.js-sika-add-to-cart-by-excel-add-form' ).on( 'submit', function ( event ) {
                event.preventDefault();
                sika.cart.addByExcel.addToCart( event.target );
            } );
            jQuery( '.js-sika-add-to-cart-by-excel-clear-form' ).on( 'click', function () {
                if ( confirm( 'Do you really want to reset the form?' ) ) {
                    sika.cart.addByExcel.reset();
                }
            } );
    
        },
        
        addByExcel: {
            registerHelpers: function () {
                Handlebars.registerHelper( 'getTranslation', function ( key ) {
                    var objTranslationData = window.sikaExcelTranslations;
                    if ( !objTranslationData || !objTranslationData[ key ] ) {
                        return key;
                    }
                    return objTranslationData[ key ];
                } );
                Handlebars.registerHelper('formatDate', function(strDate) {
                    return new Date(strDate).toLocaleDateString('da-DK').replace(/\./g, '-');
                 });
            },
            load: function ( domForm ) {
                var formData = new FormData(),
                    file = document.querySelector( '.js-sika-add-to-cart-by-excel-input' );
                formData.append( 'file', file.files[ 0 ] );

                return jQuery.ajax( {
                    url: '/integration/basketupload.ashx',
                    type: 'POST',
                    beforeSend: function () {
                        jQuery( '.js-e-page-loading-overlay' ).addClass( 'is-loading' );
                    },
                    data: formData,
                    cache: false,
                    contentType: false,
                    processData: false
                } );

            },
            sortData: function ( jsonData ) {
                var objData = {
                    errors: [],
                    products: [],
                    showCartForm: false,
                    productCount: 0
                };
                if ( typeof jsonData === 'object' ) {
                    Object.keys(jsonData).forEach( function ( strKey ) {
                        var objProduct = jsonData[strKey];
                        if ( objProduct.result.toLowerCase() === 'ok' || objProduct.result.toLowerCase() === 'outofstock' ) {
                            objData.products.push( objProduct );
                            objData.showCartForm = true;
                            objData.productCount++;
                        } else{
                            objData.errors.push( objProduct );
                        }
                    } );
                }
                sika.cart.addByExcel.build( objData );
            },
            build: function ( jsonData ) {
                jQuery( '.js-e-page-loading-overlay' ).removeClass( 'is-loading' )
                jQuery( '.js-sika-add-to-cart-by-excel-products-container' )
                    .html( e4.handlebars.tmpl.addToCartByExcelProducts( jsonData ) )
                    .find( '.js-variant-matrix-quantity' ).first().select().focus();
                jQuery( '[data-toggle="tooltip"]' ).tooltip( {
                    container: 'body'
                } );

            },
            addToCart: function ( domForm ) {
                var jDocument = jQuery( document );
                return e4.cart.ajax( {
                    data: jQuery( domForm ).serialize(),
                    beforeSend: function () {
                        jQuery( '.js-e-page-loading-overlay' ).addClass( 'is-loading' );
                    }
                }, function ( data ) {
                    var jEmptyCart = jQuery( '.js-e-empty-cart' );
                    if ( jEmptyCart.length === 1 ) {
                        location.href = jEmptyCart.data( 'redirect' );
                    }
                    e4.cart.updateContent( data );
                    jQuery( '.js-e-page-loading-overlay' ).removeClass( 'is-loading' );
                    e4.cart.updateQuantity( data.cart.productQuantity );
                    sika.cart.addByExcel.reset();
                    jDocument.trigger( e4.cart.event.productadded, data );
                } );
            },
            reset: function () {
                var jLabel = jQuery( '.js-form-group-file-label' );
                jQuery( '.js-sika-add-to-cart-by-excel-products-container' ).html( '' );
                jQuery( '.js-sika-add-to-cart-by-excel-input' ).val( '' );
                jLabel.html( jLabel.data( 'emptyText' ) );
                jQuery( '.js-sika-add-to-cart-by-excel-button' ).prop( 'disabled', true );
                jQuery( '.js-sika-add-to-cart-by-excel-upload-form' ).removeClass('d-none');
            }
        }
    };
    sika.forms = {
        addEms: function ( jForm ) {
            var formData = eval( jQuery( '#extended-form-data' ).html() ),
                jOptions = '';
            for ( var i = 0; i < formData.length; i++ ) {
                jOptions += '<option value="' + formData[ i ].em + '">' + formData[ i ].nm + '</option>';
            }
            jForm.find( 'select[name="Recipient"]' ).addClass( 'js-extended-form-recipient' ).html( jOptions );
            sika.forms.emsActions();
            sika.forms.emsSubmit();
        },
        emsActions: function () {
            jQuery( 'form.js-extended-form-with-reciepients' ).on( 'change', '.js-extended-form-recipient', function () {
                jQuery( 'input[type="hidden"][name="MailRecipient"]' ).val( jQuery( this ).val() );
            } ).trigger( 'change' );

        },
        emsSubmit: function () {
            jQuery( 'form.js-extended-form-with-reciepients' ).find( 'button[type="submit"]' ).on( 'click', function () {
                if ( jQuery( 'form.js-extended-form-with-reciepients' ).valid() ) {
                    var emsRecp = jQuery( 'form.js-extended-form-with-reciepients' ).find( 'input[type="hidden"][name="MailRecipient"]' );
                    emsRecp.val( emsRecp.val().replace( '$', '@' ).replace( /\+/g, '.' ).replace( /!/g, 'h' ).replace( /\*/g, 's' ) );
                }
            } );
        },
        init: function () {
            var jForm = jQuery( 'form.js-extended-form-with-reciepients' );
            if ( jForm.find( 'select[name="Recipient"]' ).length ) {
                sika.forms.addEms( jForm );
            }

        }
    };
    sika.nav = function () {
        var arrLocationPath = location.pathname.replace( /^\//, '' ).split( '/' ),
            jNav = jQuery( '.js-e-nav-utilities-primary' ),
            jNavActive = jNav.find( '.nav-link[href^="/' + arrLocationPath[ 0 ] +
                                    '"]' );
        if ( jNavActive.length === 0 || arrLocationPath[ 0 ] === '' ) {
            jNavActive = jNav.find( '.nav-item:first-child' ).find( '.nav-link' );
        }
        jNavActive.addClass( 'is-inpath' );
    };

    sika.customercenter = {
        init: function () {
            sika.customercenter.testForActiveTab();
            e4.util.require.js( e4.settings.require.jQueryValidate, function () {
                sika.customercenter.bindEvents();

            } );
        },
        bindEvents: function () {
            jQuery( '.js-tablist' ).on( 'shown.bs.tab', '.js-tablist-nav-link', function ( event ) {
                e4.util.hash.set( 'tab', event.target.dataset.target.replace( '#', '' ) );
            } );
            jQuery( '.js-tablist-customercenter' ).on( 'click', '.js-update-usermanagement-form', function ( event ) {
                var addressId = jQuery( this ).data( 'addressid' );
                sika.customercenter.userAddresses.update( event, addressId );
            } ).on( 'click', '.js-add-usermanagement-form', function ( event ) {
                sika.customercenter.userAddresses.changeView( event, 'Add' );
            } ).on( 'click', '.js-delete-usermanagement-form', function ( event ) {
                var addressId = jQuery( this ).data( 'addressid' );
                sika.customercenter.userAddresses.delete( this, addressId );
            } ).on( 'click', '.js-return-usermanagement-form', function ( event ) {
                sika.customercenter.userAddresses.changeView( event, 'ManageAddresses' );
            } ).on( 'click', '.js-post-usermanagement-form', function () {
                var jUserManagementForm = jQuery( event.target ).closest( 'form' );
                sika.customercenter.userAddresses.submit( jUserManagementForm, jUserManagementForm.serialize() );
            } ).on( 'submit', '#js-e-cc-list-add form, .js-e-cc-list-form-edit', function ( event ) {
                event.preventDefault();
                sika.customercenter.favorites.submit( event );
            } ).on( 'click', '.js-e-cc-list-delete, .js-e-cc-list-edit', function ( event ) {
                event.stopPropagation();
                event.preventDefault();
                sika.customercenter.favorites.post( event );
            } ).on( 'click', '.js-preview-order-details, .js-preview-order-list', function ( event ) {
                event.preventDefault();
                sika.customercenter.orders.details( event );
            } );
        },
        testForActiveTab: function () {
            var currentTab = e4.util.hash.get( 'tab' );
            if ( currentTab ) {
                jQuery( '.js-tablist-nav-link[data-target="#' + currentTab + '"]' ).tab( 'show' );
            }
            else {
                jQuery( '.js-tablist-nav-link' ).first().tab( 'show' );
            }
        },
        updateContent: function ( strHtml, tabItem ) {
            var jHtml = jQuery( strHtml ),
                jUpdatedTab = jHtml.find( '#' + tabItem.attr( 'id' ) );
            tabItem.html( jUpdatedTab.html() );
            tabItem.removeClass( 'loading' );
        },
        favorites: {
            post: function ( event ) {
                var jForm = jQuery( event.target ),
                    tabItem = jForm.closest( '.js-tab-item-module' );
                jQuery.ajax( {
                    url: jQuery( event.target ).attr( 'href' ),
                    beforeSend: function () {
                        tabItem.addClass( 'loading' );
                    },
                    dataType: 'html'
                } ).done( function ( strHtml ) {
                    sika.customercenter.updateContent( strHtml, jQuery( event.target ).closest( '.js-tab-item-module' ) );
                } );
            },
            submit: function ( event ) {
                var jForm = jQuery( event.target ),
                    tabItem = jForm.closest( '.js-tab-item-module' );
                jQuery.ajax( {
                    url: jForm.attr( 'action' ),
                    method: jForm.attr( 'method' ),
                    data: jForm.serialize(),
                    cache: false,
                    beforeSend: function () {
                        tabItem.addClass( 'loading' );
                    },
                    dataType: 'html'
                } ).done( function ( strHtml ) {
                    sika.customercenter.updateContent( strHtml, tabItem );
                    tabItem.find( 'form' ).attr( 'action', tabItem.find( 'form' ).attr( 'action' ) + '#/tab=' + e4.util.hash.get( 'tab' ) + '/' );
                } );
            }
        },
        orders: {
            details: function ( event ) {
                var tabItem = jQuery( event.target ).closest( '.js-tab-item-module' ),
                    detailsUrl = jQuery( event.target ).attr( 'href' );
                if ( !detailsUrl ) {
                    detailsUrl = jQuery( event.target ).closest( '.js-preview-order-details' ).attr( 'href' );
                }
                jQuery.ajax( {
                    url: detailsUrl,
                    beforeSend: function () {
                        tabItem.addClass( 'loading' );
                    },
                    dataType: 'html'
                } ).done( function ( strHtml ) {
                    var jHtml = jQuery( strHtml ),
                        jUpdatedForm = jHtml.find( '#' + tabItem.attr( 'id' ) );
                    if ( jHtml.find( '.js-hide-in-cc-preview' ).length > 0 ) {
                        jHtml.find( '.js-hide-in-cc-preview' ).remove();
                        jHtml.find( '.js-show-in-cc-preview' ).removeClass( 'd-none' );
                        jHtml.find( '.js-preview-order-list' ).attr( 'href', location.href );
                    }
                    tabItem.html( jUpdatedForm.html() );
                    tabItem.removeClass( 'loading' );
                } );
            }
        },
        userAddresses: {
            changeView: function ( event, view ) {
                var jUserManagementForm = jQuery( event.target ).closest( 'form' );
                jUserManagementForm.validate().settings.ignore = '*';
                sika.customercenter.userAddresses.submit( jUserManagementForm, { ManageAddressesFormAction: view } );
            },
            update: function ( event, addressId ) {
                var jUserManagementForm = jQuery( event.target ).closest( 'form' );
                jUserManagementForm.find( '#SelectedAddressId' ).val( addressId );
                jUserManagementForm.find( '#ManageAddressesFormAction' ).val( 'Update' );
                sika.customercenter.userAddresses.submit( jUserManagementForm, jUserManagementForm.serialize() );
            },
            delete: function ( domElm, addressId ) {
                var deleteDialog = confirm( jQuery( domElm ).data( 'confirm' ) );
                if ( deleteDialog === true ) {
                    var jUserManagementForm = jQuery( domElm ).closest( 'form' );
                    jUserManagementForm.find( '#SelectedAddressId' ).val( addressId );
                    jUserManagementForm.find( '#ManageAddressesFormAction' ).val( 'Delete' );
                    sika.customercenter.userAddresses.submit( jUserManagementForm, jUserManagementForm.serialize() );
                }

            },
            submit: function ( jUserManagementForm, objData ) {
                var tabItem = jUserManagementForm.closest( '.js-tab-item-module' );
                if ( jUserManagementForm.valid() === true ) {
                    return jQuery.ajax( {
                        url: jUserManagementForm.attr( 'action' ),
                        method: jUserManagementForm.attr( 'method' ),
                        data: objData,
                        cache: false,
                        beforeSend: function () {
                            tabItem.addClass( 'loading' );
                        },
                        dataType: 'html'
                    } ).done( function ( strHtml ) {
                        sika.customercenter.updateContent( strHtml, tabItem );
                        tabItem.find( 'form' ).attr( 'action', tabItem.find( 'form' ).attr( 'action' ) + '#/tab=' + e4.util.hash.get( 'tab' ) + '/' );
                        tabItem.find( 'form' ).validate();
                    } );
                }
                return false;

            }
        }
    };
    
    sika.carousel = {
        resizeDebounce: null,
        windowBaseWidth: 0,
        carouselBaseCount: 4,
        carouselCount: 0,
        _instances: [],
        init:function ( ) {
            if ( jQuery(".js-sika-plain-products-list-carousel").length > 0  ) {
                e4.util.require.js( e4.settings.require.handlebars, function () {
                    e4.handlebars.registerHelpers( 'compare' );
                    sika.carousel.handlebarsHelper();
                    e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-productlist-plain-products' );
                    sika.carousel.bindEvents();
                    sika.carousel.testCarouselCount();
                } );
            }
        },
        bindEvents: function () {
            jQuery( window ).on( 'resize', sika.carousel.testCarouselCount );
        },
        handlebarsHelper:function (  ){

                Handlebars.registerHelper( 'grouped_each', function ( every, context, options ) {
                    var out = '',
                        subcontext = [],
                        i;
                    if ( context && context.length > 0 ) {

                        var data;
                        if (options.data) {
                            data = Handlebars.createFrame(options.data);
                        }
                        
                        var slideCounter = 1;
                        
                        for ( i = 0; i < context.length; i++ ) {
                            if ( i > 0 && i % every === 0 ) {
                                if (data) {
                                    data.index = slideCounter;
                                }
                                out += options.fn( subcontext, {data: data} );
                                subcontext = [];
                                slideCounter++
                            }



                            subcontext.push( context[ i ] );
                        }
                        out += options.fn( subcontext);
                    }
                    return out;
                } );

        },
        build:function (  ) {
            jQuery( '.js-sika-plain-products-list-carousel' ).each( function ( index, domElm ) {
                if ( sika.carousel._instances[ index ] === undefined ) {
                    sika.carousel._instances[ index ] = JSON.parse( jQuery( domElm ).find( '.js-sika-plain-products-list-data' ).html() );
                }
                var data = sika.carousel._instances[ index ];
                data.carouselCount = sika.carousel.carouselCount;
                jQuery( domElm ).find( '.js-sika-plain-products-list-products' ).html( e4.handlebars.tmpl.productlistPlainProducts( data ) );
                sika.carousel.carousel( domElm );
            } );
        }, 

        testCarouselCount: function () {
            clearTimeout( sika.carousel.resizeDebounce );
            sika.carousel.resizeDebounce = setTimeout( function () {
                var windowWidth = jQuery( window ).width();
                if ( windowWidth < e4.settings.breakpoint.lg && windowWidth >= e4.settings.breakpoint.md ) {
                    sika.carousel.carouselCount = 1;
                }
                else if ( windowWidth < e4.settings.breakpoint.md ) {
                    sika.carousel.carouselCount = 1;
                }
                else {
                    sika.carousel.carouselCount = 3;
                }
                if ( sika.carousel.carouselCount !== sika.carousel.carouselBaseCount ) {
                    sika.carousel.carouselBaseCount = sika.carousel.carouselCount;
                }
                sika.carousel.build();
            }, 100 );
        },
        carousel: function ( domElm ) {
            var jCarousel = jQuery( domElm );
            if ( jCarousel.length > 0 ) {
                jCarousel.find( '.carousel-item' ).first().addClass( 'active' );
            }
        }
    };
    sika.carousel = {
        resizeDebounce: null,
        windowBaseWidth: 0,
        carouselBaseCount: 4,
        carouselCount: 0,
        _instances: [],
        init:function ( ) {
            if ( jQuery(".js-sika-plain-products-list-carousel").length > 0  ) {
                e4.util.require.js( e4.settings.require.handlebars, function () {
                    e4.handlebars.registerHelpers( 'compare' );
                    sika.carousel.handlebarsHelper();
                    e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-productlist-plain-products' );
                    sika.carousel.bindEvents();
                    sika.carousel.testCarouselCount();
                } );
            }
        },
        bindEvents: function () {
            jQuery( window ).on( 'resize', sika.carousel.testCarouselCount );
        },
        handlebarsHelper:function (  ){

            Handlebars.registerHelper( 'grouped_each', function ( every, context, options ) {
                var out = '',
                    subcontext = [],
                    i;
                if ( context && context.length > 0 ) {

                    var data;
                    if (options.data) {
                        data = Handlebars.createFrame(options.data);
                    }

                    var slideCounter = 1;

                    for ( i = 0; i < context.length; i++ ) {
                        if ( i > 0 && i % every === 0 ) {
                            if (data) {
                                data.index = slideCounter;
                            }
                            out += options.fn( subcontext, {data: data} );
                            subcontext = [];
                            slideCounter++
                        }



                        subcontext.push( context[ i ] );
                    }
                    out += options.fn( subcontext);
                }
                return out;
            } );

        },
        build:function (  ) {
            jQuery( '.js-sika-plain-products-list-carousel' ).each( function ( index, domElm ) {
                if ( sika.carousel._instances[ index ] === undefined ) {
                    sika.carousel._instances[ index ] = JSON.parse( jQuery( domElm ).find( '.js-sika-plain-products-list-data' ).html() );
                }
                var data = sika.carousel._instances[ index ];
                data.carouselCount = sika.carousel.carouselCount;
                jQuery( domElm ).find( '.js-sika-plain-products-list-products' ).html( e4.handlebars.tmpl.productlistPlainProducts( data ) );
                sika.carousel.carousel( domElm );
            } );
        },

        testCarouselCount: function () {
            clearTimeout( sika.carousel.resizeDebounce );
            sika.carousel.resizeDebounce = setTimeout( function () {
                var windowWidth = jQuery( window ).width();
                if ( windowWidth < e4.settings.breakpoint.lg && windowWidth >= e4.settings.breakpoint.md ) {
                    sika.carousel.carouselCount = 1;
                }
                else if ( windowWidth < e4.settings.breakpoint.md ) {
                    sika.carousel.carouselCount = 1;
                }
                else {
                    sika.carousel.carouselCount = 3;
                }
                if ( sika.carousel.carouselCount !== sika.carousel.carouselBaseCount ) {
                    sika.carousel.carouselBaseCount = sika.carousel.carouselCount;
                }
                sika.carousel.build();
            }, 100 );
        },
        carousel: function ( domElm ) {
            var jCarousel = jQuery( domElm );
            if ( jCarousel.length > 0 ) {
                jCarousel.find( '.carousel-item' ).first().addClass( 'active' );
            }
        }
    };

}() );

// https://github.com/constancecchen/object-fit-polyfill
// http://walterebert.com/blog/html5-video-autoplay-mobile-revisited/
